<div class="crew-modal-overlay" *ngIf="crew" (click)="close.emit()">
  <div class="crew-modal" #crewModal (click)="$event.stopPropagation()">

    <div class="crew-modal-header">
      <pss-sprite *ngIf="crewSpriteId(crew.designId)" class="crew-modal-sprite" [spriteId]="crewSpriteId(crew.designId)"></pss-sprite>
      <span class="crew-rarity rarity-{{ crewRarity(crew.designId) | lowercase }}">{{ crewRarity(crew.designId) || '...' }}</span>
      <span class="crew-modal-name">{{ crewName(crew) }}</span>
      <button class="crew-modal-close" (click)="close.emit()">✕</button>
    </div>

    <div class="crew-modal-special" *ngIf="crew && characterDesigns.get(crew.designId)?.specialAbilityType">
      <span class="crew-modal-special-key">Special Ability:</span>
      <span class="crew-modal-special-val">{{ characterDesigns.get(crew.designId)?.specialAbilityType }} {{ characterDesigns.get(crew.designId)?.specialAbilityArg }}</span>
    </div>

    <div class="crew-modal-training" *ngIf="crew && hasTraining(crew)">
      <span class="crew-modal-training-key">Perks:</span>
      <span class="crew-modal-training-val">
        HP +{{ crew.hpImp }}, Pilot +{{ crew.pilotImp }}, Attack +{{ crew.attackImp }}, Weapon +{{ crew.weaponImp }}, Science +{{ crew.scienceImp }}, Engine +{{ crew.engineImp }}, Repair +{{ crew.repairImp }}, Ability +{{ crew.abilityImp }}
      </span>
    </div>

    <div class="crew-modal-body">
      <div class="crew-modal-row">
        <span class="crew-modal-label">Level</span>
        <span class="crew-modal-val">{{ crew.level }} / {{ characterDesigns.get(crew.designId)?.maxLevel || 40 }}</span>
      </div>

      <div class="crew-modal-section-title">Stats (at max level)</div>
      <div class="crew-modal-stats-grid" *ngIf="characterDesigns.get(crew.designId) as d">
        <div class="crew-stat-cell" *ngIf="crewTotalStat(crew, 'hpImp') > 0"><span class="crew-stat-key">HP</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'hpImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="crewTotalStat(crew, 'pilotImp') > 0"><span class="crew-stat-key">Pilot</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'pilotImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="crewTotalStat(crew, 'attackImp') > 0"><span class="crew-stat-key">Attack</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'attackImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="crewTotalStat(crew, 'weaponImp') > 0"><span class="crew-stat-key">Weapon</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'weaponImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="crewTotalStat(crew, 'scienceImp') > 0"><span class="crew-stat-key">Science</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'scienceImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="crewTotalStat(crew, 'engineImp') > 0"><span class="crew-stat-key">Engine</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'engineImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="crewTotalStat(crew, 'repairImp') > 0"><span class="crew-stat-key">Repair</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'repairImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="hasAbilityStat(crew)" [title]="abilityBreakdown(crew)"><span class="crew-stat-key">Ability</span><span class="crew-stat-val">{{ crewTotalStat(crew, 'abilityImp') | number:'1.1-1' }}</span></div>
        <div class="crew-stat-cell" *ngIf="d.specialAbilityType"><span class="crew-stat-key">Special</span><span class="crew-stat-val ability">{{ d.specialAbilityType }}</span></div>
      </div>

      <ng-container *ngIf="hasTraining(crew)">
        <div class="crew-modal-section-title">Training Bonuses</div>
        <div class="crew-modal-stats-grid">
          <div class="crew-stat-cell" *ngIf="crew.hpImp !== '0'"><span class="crew-stat-key">HP</span><span class="crew-stat-val train">+{{ crew.hpImp }}</span></div>
          <div class="crew-stat-cell" *ngIf="crew.pilotImp !== '0'"><span class="crew-stat-key">Pilot</span><span class="crew-stat-val train">+{{ crew.pilotImp }}</span></div>
          <div class="crew-stat-cell" *ngIf="crew.attackImp !== '0'"><span class="crew-stat-key">Attack</span><span class="crew-stat-val train">+{{ crew.attackImp }}</span></div>
          <div class="crew-stat-cell" *ngIf="crew.weaponImp !== '0'"><span class="crew-stat-key">Weapon</span><span class="crew-stat-val train">+{{ crew.weaponImp }}</span></div>
          <div class="crew-stat-cell" *ngIf="crew.scienceImp !== '0'"><span class="crew-stat-key">Science</span><span class="crew-stat-val train">+{{ crew.scienceImp }}</span></div>
          <div class="crew-stat-cell" *ngIf="crew.engineImp !== '0'"><span class="crew-stat-key">Engine</span><span class="crew-stat-val train">+{{ crew.engineImp }}</span></div>
          <div class="crew-stat-cell" *ngIf="crew.repairImp !== '0'"><span class="crew-stat-key">Repair</span><span class="crew-stat-val train">+{{ crew.repairImp }}</span></div>
          <div class="crew-stat-cell" *ngIf="crew.abilityImp !== '0'"><span class="crew-stat-key">Ability</span><span class="crew-stat-val train">+{{ crew.abilityImp }}</span></div>
        </div>
      </ng-container>

      <ng-container *ngIf="crew && crew.equipDesignIds.length > 0">
        <div class="crew-modal-section-title">Equipment</div>
        <div class="crew-equip-list">
          <div class="crew-equip-item" *ngFor="let eq of crewEquipment(crew)">
            <div class="crew-equip-main">
              <span class="crew-equip-slot">{{ equipSlotLabel(itemDesigns.get(eq.designId)?.subtype || '') }}</span>
              <span class="crew-equip-name">{{ itemName(eq.designId) }}</span>
              <span *ngIf="eq.instanceId" class="crew-equip-instance">#{{ eq.instanceId }}</span>
            </div>
            <div class="crew-equip-bonus" *ngIf="itemStatEntriesForInstance(eq.designId, eq.instanceId).length > 0">
              <span class="crew-equip-bonus-label">Stats:</span>
              <span class="crew-equip-bonus-val" *ngFor="let b of itemStatEntriesForInstance(eq.designId, eq.instanceId)">
                {{ b.stat }} {{ b.value > 0 ? '+' : '' }}{{ b.value }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="crew-modal-section-title ai-toggle" (click)="onToggleAi()" style="cursor:pointer; user-select:none;">
        <span class="ai-toggle-label">Crew AI</span>
        <span class="toggle-arrow">{{ showAi ? '\u25b2' : '\u25bc' }}</span>
      </div>

      <ng-container *ngIf="showAi && canEditAi">
        <app-ai-editor
          [rules]="rules"
          [conditionTypes]="conditionTypes"
          [actionTypes]="actionTypes"
          [saving]="aiSaving"
          [error]="aiError"
          [emptyMessage]="'No AI rules set — crew will idle.'"
          [initialConditionId]="initialConditionId"
          [initialActionId]="initialActionId"
          [targetType]="'crew'"
          [targetId]="crew.characterId"
          [startExpanded]="true"
          [targetName]="crewName(crew)"
          [targetSpriteId]="crewSpriteId(crew.designId)"
          [compareTargets]="compareTargets"
          [compareSaving]="compareAiSaving"
          [compareError]="compareAiError"
          [userId]="userId"
          [allianceId]="allianceId"
          [userName]="userName"
          (addRule)="addRule.emit($event)"
          (deleteRule)="deleteRule.emit($event)"
          (moveRule)="moveRule.emit($event)"
          (importRules)="importRules.emit($event)"
          (deleteAllRules)="deleteAllRules.emit()"
          (deleteAllCompareRules)="deleteAllCompareRules.emit($event)"
          (editRule)="editRule.emit($event)"
          (compareEditRule)="compareEditRule.emit($event)"
          (compareAddRule)="compareAddRule.emit($event)"
          (compareDeleteRule)="compareDeleteRule.emit($event)"
          (compareMoveRule)="compareMoveRule.emit($event)"
          (compareImportRules)="compareImportRules.emit($event)"
          (copyFromCompare)="copyFromCompare.emit($event)">
        </app-ai-editor>
      </ng-container>

    </div>
  </div>
</div>
